<template>
    <vs-prompt
        color="primary"
        @accept="submit"
        @cancel="close"
        @close="close"
        :is-valid="isValid"
        :active="activePrompt"
        :title="title"
    >
        <div v-bar class="vs-scrollable" style="max-height: 550px;">
            <div>
                <div class="px-4 py-3">
                    <vs-input v-if="isInsert || isEdit" @keyup="change" @change="change" label="Name" v-model.trim="name" class="w-100 mb-4" />
                    <vs-input v-if="isInsert" @keyup="change" @change="change" type="email" label="Email" v-model.trim="username" class="w-100 mb-4" />
                    <vs-input v-if="isInsert || isChangePassword" @keyup="change" @change="change" type="password" label="Password" v-model.trim="password" class="w-100 mb-4" />
                    <vs-input v-if="isInsert || isChangePassword" @keyup="change" @change="change" type="password" label="Repeat password" v-model.trim="password2" class="w-100 mb-4" />
                    <vs-checkbox v-if="isEdit" v-model="active" color="primary" @change="change" class="mb-4">Active</vs-checkbox>
                    <vs-alert
                        :active="!isValid"
                        color="danger"
                        icon="new_releases"
                        class="mb-3">

                        Fix errors:
                        <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                    </vs-alert>
                </div>
            </div>
        </div>
    </vs-prompt>
</template>

<script>
    import { UsersService } from './../../services/users.service';
    import NProgress from 'nprogress';

    export default {
        name: 'UserForm',
        props: {
            formType: String,
            user: Object,
            activePrompt: Boolean,
            title: String
        },
        data: function () {
            return {
                id: this.user.id || 0,
                name: this.user.name || '',
                username: this.user.username || '',
                password: '',
                password2: '',
                active: this.user.active,
                errors: [],
            }
        },
        watch: {
            user: function(user) {
                this.id = user.id;
                this.name = user.name;
                this.username = user.username;
                this.active = user.status;
            }
        },
        computed: {
            isEdit: function() {
                return this.formType === 'update';
            },

            isInsert: function(){
                return this.formType === 'insert';
            },

            isChangePassword: function(){
                return this.formType === 'password';
            },

            isValid: function(){
                return this.errors.length === 0;
            }
        },
        methods: {
            validate() {
                this.errors = [];
                if ((this.isEdit || this.isInsert) && this.name === '') {
                    this.errors.push('Name is required');
                }
                if ((this.isEdit || this.isInsert) && this.username === '') {
                    this.errors.push('Email is required');
                }
                if (this.isInsert || this.isChangePassword) {
                    if (this.password.trim()==='') {
                        this.errors.push('Password cannot be blank.');
                    }
                    if (this.password !== this.password2) {
                        this.errors.push('Passwords must be equal');
                    }
                }
                return this.isValid;
            },

            change() {
                this.errors = [];
            },

            submit() {
                if (this.validate()) {
                    if (this.isInsert) {
                        NProgress.start();
                        UsersService.create({
                            name: this.name,
                            username: this.username,
                            password: this.password
                        })
                        .then( response => {
                            NProgress.done();
                            this.$vs.notify({
                                color: "success",
                                title: "User added",
                                text: "User is added"
                            });

                            this.id = 0;
                            this.name = '';
                            this.username = '';
                            this.password = '';
                            this.password2 = '';
                            this.active = 0;
                            this.errors = [];
                            this.$emit('userCreated', response.data);
                            this.$emit('isClosed');
                        })
                        .catch( error => {
                            NProgress.done();
                            if (error.code==422) {
                                error.errors.forEach(errorItem => this.errors.push(errorItem.message));
                            }
                        });
                    } else if(this.isEdit) {
                        NProgress.start();
                        UsersService.update(this.id, {
                            name: this.name,
                            status: this.active ? 1 : 0
                        }).then( response => {
                            NProgress.done();
                            this.$vs.notify({
                                color: "success",
                                title: "User updated",
                                text: "User is updated"
                            });
                            this.password = '';
                            this.password2 = '';
                            this.errors = [];
                            this.$emit('userUpdated', response.data);
                            this.$emit('isClosed');
                        })
                        .catch( error => {
                            NProgress.done();
                            if (error.code==422) {
                                error.errors.forEach(errorItem => this.errors.push(errorItem.message));
                            }
                        });
                    } else if (this.isChangePassword) {
                        NProgress.start();
                        UsersService.changePassword(this.id, this.password)
                            .then( () => {
                                NProgress.done();
                                this.$vs.notify({
                                    color: "success",
                                    title: "Password changed",
                                    text: "Password is successfully changed"
                                });

                                this.id = 0;
                                this.name = '';
                                this.username = '';
                                this.password = '';
                                this.password2 = '';
                                this.active = 0;
                                this.errors = [];
                                this.$emit('isClosed');
                            })
                            .catch( error => {
                                NProgress.done();
                                if (error.code ==  422) {
                                    error.errors.forEach(errorItem => this.errors.push(errorItem.message));
                                }
                            });
                    }
                    return true;
                }

                return false;
            },

            close() {
                this.name = this.user.name;
                this.username = this.user.username;
                this.active = this.user.status;
                this.password = '';
                this.password2 = '';
                this.errors = [];
                this.$emit('isClosed');
            }
        }
    }
</script>

<style>
    .vs-alert {
        white-space: normal !important;
    }
    .con-vs-dialog .vs-dialog {
        max-width: 600px !important;
    }
</style>
